import { Controller } from "@hotwired/stimulus"

// Reads any data-style-<prop> attribute on the element and applies it as
// a CSS property via element.style.setProperty(). JS-driven style mutations
// are not blocked by CSP style-src, so this is the mechanism for dynamic
// continuous-value styling under strict CSP.
//
// Usage:
//   <div data-controller="style-props"
//        data-style-width="50%"
//        data-style-background-color="#54509e">
//
// Multiple data-style-* attributes are supported on the same element.
// Do not add static values/targets/classes to this controller — Stimulus-
// generated attributes (data-style-props-*-value, etc.) would collide with
// the data-style-* match pattern and trigger setProperty with invalid names.
export default class extends Controller {
  connect() {
    for (const { name, value } of this.element.attributes) {
      const match = name.match(/^data-style-(.+)$/)
      if (match) this.element.style.setProperty(match[1], value)
    }
  }
}
